import DatePicker, { DatePickerState } from "@insite/mobius/DatePicker";
import React, { useEffect, useState } from "react";
import translate from "@insite/client-framework/Translate";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { ResolveThunks, connect, useDispatch } from "react-redux";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { Cart } from "@NA/Overrides/Services/CartService";
import { cloneDeep } from "lodash";
import { CartLineModel, CartModel, PickUpLocation } from "@insite/client-framework/Types/ApiModels";
import ADICheckoutModalWrapper from "@NA/Components/CheckoutShippingAddresses/ADICheckoutModalWrapper";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Button, GridContainer, GridItem, LazyImage, Typography } from "@insite/mobius/index";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";
import { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { ButtonProps } from "@insite/mobius/Button";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ADIColors from "@NA/Utils/ADIColors";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridOffset } from "@insite/mobius/GridContainer";
import { negitiveOffsetADITime, isHourBefore } from "@NA/Utilities/CheckoutUtilities";
import checkoutCart, { CheckoutCartParameter } from "@NA/Handlers/ADICheckoutCartHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";

import loadCartSummary from "@NA/Handlers/ADIGetCartSummaryMethodHandler";

import { LoadCartApiInterface } from "@NA/Handlers/LoadCartExtended";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";

interface OwnProps {
    datepickerStyles: any;
    setPickUpDate: any;
    selectedState: PickUpLocation | undefined;
    setIsShowOneHourPickup: any;
    oneHourPickupHandler: any;
    adiLockerCheck?: boolean;
    disabled?: boolean;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    return {
        cart,
        pickUpDates: cart ? cart.pickUpDates : null,
        cartRedirectUrl: getPageLinkByPageType(state, "Cart")?.url,
        localCart: state.ADIGlobalData.checkoutCartStore.cart,
    };
};

const mapDispatchToProps = {
    loadCurrentCart,
    loadCart,
    loadCartSummary,
    checkoutCart
};

export interface ADIPickUpBranchDateStyle {
    modalContainer?: InjectableCss;
    heading?: TypographyProps;
    productGridContainer?: GridContainerProps;
    brandShortDesc?: TypographyProps;
    productNumber?: TypographyProps;
    modelNumber?: TypographyProps;
    stockNotAvailable?: TypographyProps;
    stockNotAvailableRed?: TypographyProps;
    stockNotAvailableGridItem?: GridItemProps;
    actionGridContainer?: GridContainerProps;
    itemWrapper?: InjectableCss;
    actionGridItem1?: GridItemProps;
    actionGridItem2?: GridItemProps;
    continueButton?: ButtonProps;
    editButton?: ButtonProps;
    changeButton?: ButtonProps;
    hideIcons?: InjectableCss;
    pickUpDateWrap?: InjectableCss;
    productGridmodalContainer?: InjectableCss;
    productimgContainer?: InjectableCss;
    productinfoContainer?: InjectableCss;
    actionGridItem0?: InjectableCss;
    headingoutofstock?: InjectableCss;
    headingoutofstockimg?: InjectableCss;
    lazyimagestyle?: InjectableCss;
    itemWrappercart?: InjectableCss;
}

export const adiPickUpBranchDateStyle: ADIPickUpBranchDateStyle = {
    modalContainer: {
        css: css`
            padding-bottom: 5px;
            max-height: 480px;
            overflow-y: scroll !important;
            overflow-x: hidden;
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            ${GridWrapper} {
                                max-width: 100%;
                                flex-basis: 100%;
                            }
                        `,
                        css``,
                        css``,
                    ],
                    "max",
                )}
        `,
    },

    heading: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            padding-top: 0;
            padding-bottom: 40px;
        `,
    },

    itemWrapper: {
        css: css`
            margin-bottom: 20px;
            ${GridOffset} {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                margin-bottom: 0px;
                            `,
                        css`
                                margin-bottom: 0px;
                            `,
                        css`
                                margin-bottom: 20px;
                            `,
                        css`
                                margin-bottom: 20px;
                            `,
                        css`
                                //  padding-top:0px;
                            `,
                    ],
                    "max",
                )}
            }
        `,
    },

    itemWrappercart: {
        css: css`
            margin-bottom: 20px;
            ${GridOffset} {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                margin-bottom: 0px;
                            `,
                        css`
                                margin-bottom: 0px;
                            `,
                        css`
                                margin-bottom: 20px;
                            `,
                        css`
                                margin-bottom: 20px;
                            `,
                        css`
                                //  padding-top:0px;
                            `,
                    ],
                    "max",
                )}
            }
        `,
    },
    productGridContainer: {
        css: css`
            img {
                margin: 15px;
            }
            border-bottom: 1px solid ${ADIColors.gray3};
            // padding-bottom: 20px;
            // padding-top: 22px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 40px;
                        `,
                        css`
                            margin-top: 40px;
                        `,
                        css`
                            margin-bottom: 20px;
                        `,
                        css`
                            margin-bottom: 20px;
                        `,
                        css`
                            //  padding-top:0px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    brandShortDesc: {
        css: css`
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 5px;
        `,
    },
    productNumber: {
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: 600;
            margin-bottom: 5px;
        `,
    },
    modelNumber: {
        color: ADIColors.gray4,
        css: css`
            font-size: 12px;
            font-weight: 600;
        `,
    },
    stockNotAvailableRed: {
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: bold;
            font-color:#ac1e2d !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 0px;
                        `,
                        css`
                            margin-bottom: 0px;
                        `,
                        null,
                        null,

                        null,
                    ],
                    "max",
                )}
        `,
    },

    stockNotAvailable: {
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            font-weight: bold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 0px;
                        `,
                        css`
                            margin-bottom: 0px;
                        `,
                        null,
                        null,

                        null,
                    ],
                    "max",
                )}
        `,
    },
    actionGridContainer: {
        css: css`
            margin-top: 40px;
            margin-bottom: 10px;
            padding-left: 5px;
            padding-right: 5px;
            min-width: 222px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 22px;
                        `,
                        css`
                            margin-top: 22px;
                        `,
                        null,
                        null,

                        null,
                    ],
                    "max",
                )}
        `,
    },

    continueButton: {
        css: css`
            min-width: 222px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            width: 100%;
                            padding: 15px 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    editButton: {
        css: css`
            min-width: 222px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 15px 0px;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    changeButton: {
        css: css`
            min-width: 222px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 15px 10px;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    hideIcons: {
        css: css`
            display: none;
        `,
    },
    pickUpDateWrap: {
        css: css`
            ${FormFieldStyle} {
                ${FormInputWrapper} {
                    .react-datetime-picker {
                        padding: 0 15px 0 15px;
                        color: ${ADIColors.darkBlack3};
                        .react-datetime-picker__inputGroup__input {
                            color: ${ADIColors.darkBlack3};
                        }
                        .react-calendar__navigation__label {
                            pointer-events: none;
                        }
                    }
                }
            }
        `,
    },

    productGridmodalContainer: {
        css: css`
            border-bottom: 1px solid ${ADIColors.gray3};
            padding-bottom: 20px;
            padding-top: 22px;

            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [css``, css``, css``, css``, css``])}
        `,
    },
    productimgContainer: {
        css: css`
        img { 
            margin: 15px; 
        }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-width: 106px;
                        max-width: 106px;
                        max-height: 78px;
                        height: auto;
                        width: auto;
                    `,
                    css`
                        min-width: 106px;
                        max-width: 106px;
                        max-height: 78px;
                        height: auto;
                        width: auto;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                        min-width: 113px;
                        max-width: 113px;
                        max-height: 78px;
                        height: auto;
                        width: auto;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    productinfoContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 5px;
                    `,
                    css`
                        padding-bottom: 5px;

                        flex-basis: 60%;
                        max-width: 60%;
                    `,
                    css`
                        flex-basis: 60%;
                        max-width: 60%;
                    `,
                    css`
                        flex-basis: 65%;
                        max-width: 65%;
                    `,
                    css``,
                ])}
        `,
    },
    stockNotAvailableGridItem: {
        align: "middle",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 122px !important;
                        width: 100% !important;
                        max-width: 100% !important;

                        padding-top: 0px !important;
                        padding-bottom: 0px !important;
                    `,
                    css`
                        // padding-left: 128px !important;
                        // width: 100% !important;
                        // max-width: 100% !important;

                        // padding-top: 0px !important;
                        // padding-bottom: 0px !important;

                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css``,
                ])}
        `,
    },
    actionGridItem1: {
        css: css`
            display: flex;
            gap: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 10px;
                    `,
                    css`
                        // padding-top:10px;
                        max-width: 32%;
                        margin-right: 30px !important;

                        padding: 15px 0px;
                    `,
                    css`
                        max-width: 32%;
                        margin-right: 30px !important;

                        padding: 15px 0px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    actionGridItem2: {
        css: css`
            display: flex;
            justify-content: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css`
                        padding: 15px 0px 15px 15px;
                        max-width: 28%;
                        margin-left: 0px !important;
                    `,
                    css`
                        padding: 15px 0px 15px 15px;
                        max-width: 28%;
                        margin-left: 0px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    actionGridItem0: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 0px;
                    `,
                    css`
                        // padding-bottom: 0px;
                        max-width: 31%;
                        margin-right: 20px !important;

                        padding: 15px 10px;
                    `,
                    css`
                        max-width: 31%;
                        margin-right: 20px !important;

                        padding: 15px 10px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    headingoutofstock: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            padding-top: 0;
            padding-bottom: 40px;
            img {
                margin-right: 10px;
                position: relative;
                top: 4px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: 6px;
                            font-size: 14px;
                            display: flex;
                            padding-right: 10px;
                        `,
                        css`
                            padding-bottom: 6px;
                            font-size: 14px;
                            display: flex;
                            padding-right: 10px;
                        `,
                        null,
                        null,

                        null,
                    ],
                    "max",
                )}
            img {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                margin-right: 10px;
                                display: inline-block;
                                vertical-align: middle;
                                height: 17.3px;
                                width: 22px;
                                bottom: -6px;
                                position: relative;
                            `,
                        css`
                                margin-right: 10px;
                                display: inline-block;
                                vertical-align: middle;
                                height: 17.3px;
                                width: 22px;
                                bottom: -6px;
                                position: relative;
                            `,
                        null,
                        null,

                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    headingoutofstockimg: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-right: 10px;
                            display: inline-block;
                            vertical-align: middle;
                            height: 17.3px;
                            width: 22px;
                            bottom: 10px;
                        `,
                        css`
                            margin-right: 10px;
                            display: inline-block;
                            vertical-align: middle;
                            height: 17.3px;
                            width: 22px;
                            bottom: 10px;
                        `,
                        css`
                            margin-right: 10px;
                        `,
                        null,

                        null,
                    ],
                    "max",
                )}
        `,
    },
    lazyimagestyle: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 78px;
                        `,
                        css`
                            height: 78px;
                        `,
                        css`
                            height: 78px;
                        `,
                        null,

                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = adiPickUpBranchDateStyle;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const ADIPickUpBranchDate = ({
    datepickerStyles,
    pickUpDates,
    cart,
    history,
    cartRedirectUrl,
    setPickUpDate,
    selectedState,
    setIsShowOneHourPickup,
    oneHourPickupHandler,
    checkoutCart,
    adiLockerCheck,
    disabled,
    loadCartSummary,
}: Props) => {
    const dispatch = useDispatch();

    // need to modify and call in use effect
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const maxDateValue = new Date(today);
    maxDateValue.setDate(today.getDate() + 7);
    const [sameDayPickUpModal, setSameDayPickUpModal] = useState(false);
    const [itemsAvailableToSupply, setItemsAvailableToSupply] = useState(false);
    const [itemsNotAvailable, setItemsNotAvailable] = useState<CartLineModel[]>();
    const [itemsAvailable, setItemsAvailable] = useState<CartLineModel[]>();
    const [pickUpLocations, setPickUpLocations] = useState(cart ? cart.pickUpLocations : []);

    // Dates State
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const [pickUpDatesOnly, setPickUpDatesOnly] = useState<Date[]>();
    const [selectedDate, setSelectedDate] = useState(tomorrow);
    const [selectedAdonisDate, setSelectedAdonisDateDate] = useState("");

    const inputDate = new Date(selectedDate?.toDateString());
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const year = inputDate.getFullYear().toString().slice(2);

    const [isCalendarOpen, setIsCalendarOpen] = useState(false);

    const formattedDate = `${year}${month}${day}`;

    useEffect(() => {
        inits();
    }, [selectedState]);

    useEffect(() => {
        setPickUpDate(selectedDate);
    }, [selectedDate]);

    const inits = () => {
        if (!cart) return;
        if (!selectedState) return;
        const pickUpLocationsValue = cloneDeep(cart.pickUpLocations);
        const adiOffsetTime = negitiveOffsetADITime(selectedState.timeOffset);
        const before4 = isHourBefore(adiOffsetTime, 16);
        const excludeToday: boolean = !before4;
        const pickUpDatesValue: any = [];
        pickUpDates?.forEach((element: any, i: number) => {
            if (!(i === 0 && excludeToday)) {
                pickUpDatesValue.push(new Date(element.date));
            }
        });
        setStartDate(pickUpDatesValue[0]);
        let currentEndDate = pickUpDatesValue[pickUpDatesValue.length - 1];
        let updatedEndDate = new Date(currentEndDate);
        updatedEndDate.setDate(updatedEndDate.getDate() + 1);
        setEndDate(updatedEndDate);
        if (pickUpDates) setSelectedAdonisDateDate(pickUpDates[0].adonisDate);
        if (pickUpDates && pickUpDates.length > 1) {
            setSelectedDate(pickUpDatesValue[1]);
            dispatch({
                type: "Custom/UpdateInitialPickupDate",
                result: excludeToday ? pickUpDates[2]?.adonisDate : pickUpDates[1]?.adonisDate,
            });
            setPickUpDate(pickUpDatesValue[1]);
        }
        setPickUpLocations(pickUpLocationsValue);
        setPickUpDatesOnly(pickUpDatesValue);
    };

    const redirectToCartPage = () => {
        history.push("/Cart");
    };

    const redirectToCheckOutPage = () => {
        window.location.reload();
    };

    const updateDate = async (newSelectedDate: Date) => {
        if (!cart) return;
        let newAdonisDate = "";
        cart.pickUpDates?.forEach((item: any) => {
            let d1 = new Date(item.date);

            if (d1.getTime() === newSelectedDate.getTime()) {
                newAdonisDate = item.adonisDate;
                dispatch({
                    type: "Custom/UpdateInitialPickupDate",
                    result: newAdonisDate,
                });
                setPickUpDate(newAdonisDate);
            } else if (d1.getDate() === newSelectedDate.getDate()) {
                newAdonisDate = item.adonisDate;
                dispatch({
                    type: "Custom/UpdateInitialPickupDate",
                    result: newAdonisDate,
                });
                setPickUpDate(newAdonisDate);
            }
        });

        const cartClone: Cart = cloneDeep(cart);
        cartClone.properties.isPickUp = "Y";
        cartClone!.properties["pickUpDate"] = newAdonisDate || "";
        cartClone!.properties["requestedOrderDate"] = formattedDate || "";
        cartClone!.properties["adiLockInd"] = adiLockerCheck ? "Y" : "N";
        cartClone!.fulfillmentMethod = "Pickup";

        checkoutCart({
            cart: { ...cartClone, },
            // OnSuccess Implementation ------P21 Change
            onSuccess(result: CheckoutCartParameter) {
                loadCart({
                    cartId: cartClone?.id || "current",
                    loading: false,
                    showLoad: false,
                } as LoadCartApiInterface);
                loadCartSummary({ cart: cartClone });
                dispatch({ type: "Custom/DeliveryMethodChanges/CompleteLoading", result: false });
            },
        });

    };

    const handleDatePickerChange = async (newSelectedDate: DatePickerState) => {
        if (cart && cart.cartLines && newSelectedDate && newSelectedDate.selectedDay) {
            if (selectedState && selectedDate) {
                const isWillCallRush = ["A", "R"].includes(selectedState.code);
                const adiOffsetTime = negitiveOffsetADITime(selectedState.timeOffset);
                const today = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
                const before3 = isHourBefore(adiOffsetTime, 15);
                const before4 = isHourBefore(adiOffsetTime, 16);
                const todayDateVals = today.split("/");
                const todayDate = new Date(
                    parseInt(todayDateVals[0]),
                    parseInt(todayDateVals[1]) - 1,
                    parseInt(todayDateVals[2]),
                );
                const isToday = todayDate.toDateString() == newSelectedDate.selectedDay.toDateString();

                const itemsAreShort = cart?.cartLines.filter(x => x.properties["itemsAreShort"] == "True").length > 0;
                const noItemsAvailable =
                    cart?.cartLines.filter(x => x.properties["noItemsAvailable"] == "True").length > 0;
                const itemsAvailableToSupplyValue =
                    cart.cartLines.filter(
                        x => x.properties["itemsAreShort"] == "False" && x.properties["noItemsAvailable"] == "False",
                    ).length == 0;

                setItemsAvailableToSupply(itemsAvailableToSupplyValue);

                if (itemsAvailableToSupplyValue || !isToday) {
                    setIsShowOneHourPickup(false);
                    oneHourPickupHandler(false, true);
                } else {
                    setIsShowOneHourPickup(true);
                    oneHourPickupHandler(false, true);
                }

                const itemsNotAvailableValue = cart.cartLines.filter(
                    x => x.properties["itemsAreShort"] == "True" || x.properties["noItemsAvailable"] == "True",
                );
                setItemsNotAvailable(itemsNotAvailableValue);
                const itemsAvailableValue = cart.cartLines.filter(
                    x => x.properties["itemsAreShort"] == "False" && x.properties["noItemsAvailable"] == "False",
                );

                setItemsAvailable(itemsAvailableValue);
                if (isWillCallRush && isToday && before3) {
                    if (itemsAreShort || noItemsAvailable) {
                        setSameDayPickUpModal(true);
                    }
                }

                if (newSelectedDate && newSelectedDate.selectedDay) {
                    setSelectedDate(newSelectedDate.selectedDay);
                    updateDate(newSelectedDate.selectedDay);
                }
            }
        }
    };

    const onSameDayPickUpModalClose = () => {
        setSameDayPickUpModal(false);
    };

    const dateChangePickup = async (newSelectedDate: DatePickerState) => {
        if (!cart) {
            return;
        }
        setIsShowOneHourPickup(false);
        handleDatePickerChange(newSelectedDate);
    };
    return (
        <>
            {pickUpDatesOnly && (
                <StyledWrapper {...styles.pickUpDateWrap}>
                    <DatePicker
                        {...datepickerStyles}
                        onDayChange={newSelectedDate => {
                            dateChangePickup(newSelectedDate);
                        }}
                        selectedDay={selectedDate}
                        sizeVariant="small"
                        disabled={isCalendarOpen || disabled}
                        clearIconProps={{ ...styles.hideIcons }}
                        calendarIconProps={{ ...styles.hideIcons }}
                        dateTimePickerProps={{
                            maxDate: endDate, // Set maxDate to 6 days from today
                            tileDisabled: ({ date }: { date: Date }) => {
                                // Convert both dates to ISO strings for comparison
                                const formattedDate = date.toISOString().slice(0, 10);
                                // Check if the date is in the list of disabled dates (Saturdays and Sundays)
                                return !pickUpDatesOnly.some(
                                    (disabledDate: any) => disabledDate.toISOString().slice(0, 10) === formattedDate,
                                );
                            },
                        }}
                    />
                </StyledWrapper>
            )}

            <ADICheckoutModalWrapper
                headline={translate("Some items are not in stock")}
                subheading={translate("The following items are not in stock and will not be ready for pickup today.")}
                isOpen={sameDayPickUpModal}
                errorStyle={false}
                handleClose={onSameDayPickUpModalClose}
            >
                <StyledWrapper {...styles.modalContainer}>
                    <Typography as="p" {...styles.headingoutofstock}>
                        <img
                            {...styles.headingoutofstockimg}
                            src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/np-warning.png"
                        />
                        {translate("The following items are not in stock and will not be ready for pickup today.")}
                    </Typography>
                    <StyledWrapper {...styles.itemWrappercart}>
                        {itemsNotAvailable?.map(item => {
                            return (
                                <GridContainer key={item.id} {...styles.productGridContainer}>
                                    <GridItem width={[4, 4, 4, 2, 2]} {...styles.productimgContainer}>
                                        <LazyImage
                                            {...styles.lazyimagestyle}
                                            altText={item.altText}
                                            src={item.smallImagePath}
                                        />
                                    </GridItem>
                                    <GridItem width={[8, 8, 8, 6, 6]} {...styles.productinfoContainer}>
                                        <StyledWrapper>
                                            <StyledWrapper>
                                                <Typography as="p" {...styles.brandShortDesc}>
                                                    {item.properties.branD_SHORTDESC}
                                                </Typography>
                                                <Typography as="p" {...styles.productNumber}>
                                                    {item.productName}
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper>
                                                <Typography as="p" {...styles.modelNumber}>
                                                    {item.erpNumber} |{" "}
                                                    {item.modelNumber != "" ? item.modelNumber : item.manufacturerItem}
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem width={[12, 12, 12, 4, 4]} {...styles.stockNotAvailableGridItem}>
                                        <Typography as="p" {...styles.stockNotAvailableRed}>
                                            {item.qtyOrdered} in Cart ({item.properties["localInventory"]}) in Stock
                                        </Typography>
                                    </GridItem>
                                </GridContainer>
                            );
                        })}
                    </StyledWrapper>

                    {/* For Pick Available Item */}
                    {!itemsAvailableToSupply && (
                        <Typography as="p" {...styles.heading}>
                            {translate("These items are in stock and will be available for pickup today.")}
                        </Typography>
                    )}
                    <StyledWrapper {...styles.itemWrapper}>
                        {itemsAvailable?.map(item => {
                            return (
                                <GridContainer key={item.id} {...styles.productGridContainer}>
                                    <GridItem width={[4, 4, 4, 2, 2]}>
                                        <LazyImage altText={item.altText} src={item.smallImagePath} />
                                    </GridItem>
                                    <GridItem width={[8, 8, 8, 6, 6]}>
                                        <StyledWrapper>
                                            <StyledWrapper>
                                                <Typography as="p" {...styles.brandShortDesc}>
                                                    {item.properties.branD_SHORTDESC}
                                                </Typography>
                                                <Typography as="p" {...styles.productNumber}>
                                                    {item.productName}
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper>
                                                <Typography as="p" {...styles.modelNumber}>
                                                    {item.erpNumber} |{" "}
                                                    {item.modelNumber != "" ? item.modelNumber : item.manufacturerItem}
                                                </Typography>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem width={[12, 12, 12, 4, 4]} {...styles.stockNotAvailableGridItem}>
                                        <Typography as="p" {...styles.stockNotAvailable}>
                                            {translate("In Stock")}
                                        </Typography>
                                    </GridItem>
                                </GridContainer>
                            );
                        })}
                    </StyledWrapper>

                    <GridContainer {...styles.actionGridContainer}>
                        <GridItem width={[12, 12, 12, 4, 4]} {...styles.actionGridItem0}>
                            <Button onClick={redirectToCheckOutPage} {...styles.changeButton} variant="secondary">
                                {translate("Change Delivery Option ")}
                            </Button>
                        </GridItem>
                        <GridItem width={[12, 12, 12, 4, 4]} {...styles.actionGridItem1}>
                            <Button onClick={redirectToCartPage} {...styles.editButton} variant="secondary">
                                {translate("Edit Products in Cart ")}
                            </Button>
                        </GridItem>
                        <GridItem width={[12, 12, 12, 4, 4]} {...styles.actionGridItem2}>
                            <Button onClick={onSameDayPickUpModalClose} {...styles.continueButton} variant="primary">
                                {translate("Continue")}
                            </Button>
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            </ADICheckoutModalWrapper>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(ADIPickUpBranchDate));
